import { Component, h } from 'preact';
import { Localizer } from 'preact-i18n';
import * as appStyles from '../../../assets/global.scss';
import { Actions, actions, AmSelectionState, BookingState, connectStore } from '../../../store';
import { WithStyles, withStyles } from '../../../style';
import { Properties, ContentType } from '../../../common';
import Icon from '../../../common/Icon/Icon';
import { Modal, ModalBody, ModalButton, ModalFooter, ModalHeader, ModalTitle } from '../../../modal';
import { amDeepLink } from '../../../utils/deeplinkUtils';
import { EnvConfig } from '../../../config';
import { FinText } from '../../../i18n';

interface StoreProps {
  amSelection: AmSelectionState;
  envConfig: EnvConfig;
  contentType: ContentType;
}

export interface AmContinueModalProps extends Properties {}

const mapStateToProps = ({ amState, envConfig, contentType }: BookingState): StoreProps => ({
  amSelection: amState.amSelection,
  envConfig,
  contentType,
});

type EffectiveProps = StoreProps & Actions & AmContinueModalProps & WithStyles;

@withStyles(appStyles)
@connectStore({ mapStateToProps, actions })
export default class AmContinueModal extends Component<AmContinueModalProps> {
  continue = (): void => {
    const { proceedToAurinkomatkat } = this.props as EffectiveProps;
    proceedToAurinkomatkat();
  };

  cancel = (): void => {
    const { hideModal } = this.context.modal;
    hideModal();
  };

  render({ tx, amSelection, envConfig, contentType }: EffectiveProps): h.JSX.Element {
    const holidayType = amSelection.locations?.holidayType?.label;

    return (
      <Modal class="bw-am-continue-modal">
        <ModalHeader>
          <ModalTitle>
            <FinText id="aurinkomatkat.continueModal.title" fields={{ holidayType }} />
          </ModalTitle>
        </ModalHeader>
        <ModalBody class={tx('ps-large font-body-1')}>
          <div class="flex flex--middle ps-small-b">
            <Icon iconName="am-logo" class="ir-medium" />
            <div class="nordic-blue-900-text mr-xsmall-l font-heading-3">
              <FinText id="aurinkomatkat.continueModal.contentTitle" />
            </div>
          </div>

          <FinText id="aurinkomatkat.continueModal.content" />
        </ModalBody>
        <ModalFooter>
          <Localizer>
            <ModalButton class={tx('ms-small-r')} onClick={this.cancel}>
              <div class="relative">
                <FinText id="action.cancel" />
              </div>
            </ModalButton>
          </Localizer>
          <Localizer>
            <a
              href={`${amDeepLink(amSelection, envConfig)}&utm_content=${contentType}`}
              target="_blank"
              rel="noreferrer"
            >
              <ModalButton onClick={this.continue} cta data-test-am-modal-cta>
                <div class="relative">
                  <FinText id="action.continue" />
                </div>
              </ModalButton>
            </a>
          </Localizer>
        </ModalFooter>
      </Modal>
    );
  }
}
